export const GET_ADDRESSLIST_REQUEST = "GET_ADDRESSLIST_REQUEST";
export const GET_ADDRESSLIST_SUCCESS = "GET_ADDRESSLIST_SUCCESS";
export const GET_ADDRESSLIST_FAIL = "GET_ADDRESSLIST_FAIL";
